// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileComplianceBlock-modulecontent__h18UI";
var _2 = "ApplicantProfileComplianceBlock-modulefactLabel__bx_g3";
var _3 = "ApplicantProfileComplianceBlock-modulefactValue__u_KS2";
var _4 = "ApplicantProfileComplianceBlock-modulefacts__BZPKL";
var _5 = "ApplicantProfileComplianceBlock-moduleline__X3uuW";
var _6 = "ApplicantProfileComplianceBlock-modulelines__atURL";
export { _1 as "content", _2 as "factLabel", _3 as "factValue", _4 as "facts", _5 as "line", _6 as "lines" }
